<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Search condition') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormInputText fieldName="last_name"
                                       label="Last name"
                                       size="4"
                                       :isFocus="true"
                                       v-model:field="search.last_name" />

                        <FormInputText fieldName="first_name"
                                       label="First name"
                                       size="4"
                                       v-model:field="search.first_name" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="4"
                                       v-model:field="search.email" />

                    </div>

                    <div class="grid">
                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="4"
                                       v-model:field="search.phone" />

                        <FormSelect fieldName="is_locked"
                                    label="Is user locked?"
                                    size="4"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_locked" />

                        <FormSelect fieldName="is_active"
                                    label="Is active user?"
                                    size="4"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_active" />
                    </div>


                    <div class="grid">
                        <FormSelect fieldName="is_system_user"
                                    label="System account"
                                    size="4"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_system_user" />

                        <FormSelect fieldName="is_password_policy"
                                    label="Is password policy?"
                                    size="4"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_password_policy" />

                        <FormSelect fieldName="is_login_behalf"
                                    label="Possibility to login to foreign accounts"
                                    size="4"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_login_behalf" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="position_id"
                                         label="Position"
                                         size="6"
                                         showClear
                                         :options="select?.positions"
                                         v-model:field="search.positions" />

                        <FormMultiselect fieldName="dept_id"
                                         label="Department"
                                         size="6"
                                         showClear
                                         :options="select?.depts"
                                         v-model:field="search.depts" />
                    </div>
                    <div class="grid">
                        <FormMultiselect fieldName="role_id"
                                         label="Role"
                                         size="6"
                                         showClear
                                         :options="select?.roles"
                                         :filter="(event) => onFilter(event, 'roles')"
                                         v-model:field="search.roles" />

                        <FormMultiselect v-if="multiModuleApp"
                                         fieldName="module_symbols"
                                         label="Modules"
                                         size="6"
                                         showClear
                                         :options="select?.modules"
                                         v-model:field="search.modules" />
                        <FormStaticText v-else
                                        label=""
                                        size="4" />

                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>


        <div class="grid w-full">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref, onBeforeMount } from "vue";

import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from "@crud/FormInputText.vue";
import FormMultiselect from "@crud/FormMultiselect.vue";
import FormSelect from "@crud/FormSelect.vue";
import FormStaticText from "@crud/FormStaticText.vue";

import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch, yesNoOptions } from '@pages/Helper/crud_utils.js'
import { __, getConfigOptions } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

const options = ["roles", "positions", "depts", "modules"];
const select = ref(null);
const multiModuleApp = ref(false)

let search = ref({})

prepareSearch(search, props, options, select)

// -----------------------------------------------------

onBeforeMount(async () => {
    multiModuleApp.value = await getConfigOptions('multiModuleApp')
});

// -----------------------------------------------------


</script>

<style lang="scss" scoped>
:deep(.grid) {
    align-items: flex-end;
}

:deep(.grid > .field) {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

:deep(.grid > .field > label) {
    margin-bottom: 0.25rem;
}
</style>
